import { Trans } from '@lingui/react/macro'
import { ButtonFilled } from '@vgw/multibrand-fe-button'
import {
  somethingWentWrongNormal,
  somethingWentWrongHiDPI,
} from '@/features/something-went-wrong-assets'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'
import { getBrandConfig } from '@/config/config'
import { useOidc, getOidc } from '@/features/oidc/oidc'
import { useCallback } from 'react'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'

export const Route = createFileRoute('/inactivity-logout')({
  component: InactivityLogout,
  validateSearch: zodValidator(
    z.object({
      redirect_uri: z.string().optional(),
    }),
  ),
  beforeLoad: async ({ search }) => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      const url = search.redirect_uri ? new URL(search.redirect_uri) : null
      return redirect({
        to: url ? `${url.pathname}${url.search}${url.hash}` : '/',
      })
    }
  },
})

function InactivityLogout() {
  const { name } = getBrandConfig()
  const { login, isUserLoggedIn } = useOidc()
  const navigate = Route.useNavigate()
  const redirectUrlString = Route.useSearch({
    select: ({ redirect_uri }) => redirect_uri,
  })

  const handleLogin = useCallback(() => {
    if (!isUserLoggedIn) {
      login({ redirectUrl: redirectUrlString || '/' })
      return
    } else {
      navigate({
        to: redirectUrlString || '/',
        replace: true,
      })
    }
  }, [login, navigate, redirectUrlString, isUserLoggedIn])

  return (
    <Layout>
      <Content>
        <main className="flex w-full flex-col bg-page-small-background bg-cover bg-top bg-no-repeat">
          <div className="flex flex-shrink-0 flex-col items-center gap-4 bg-page-gradient px-8 py-10">
            <img
              className="size-32"
              alt=""
              aria-hidden={true}
              src={somethingWentWrongNormal}
              srcSet={`${somethingWentWrongNormal} 122w, ${somethingWentWrongHiDPI} 244w `}
            />
            <div className="flex flex-col items-center gap-3 text-center">
              <h1 className="font-display text-2xl leading-9 font-bold tracking-normal">
                <Trans>You&apos;ve been logged out due to inactivity</Trans>
              </h1>
              <p className="font-display">
                <Trans>Please log in again to continue playing {name}</Trans>
              </p>
              <ButtonFilled onClick={handleLogin}>
                <Trans>Log in</Trans>
              </ButtonFilled>
            </div>
          </div>
        </main>
      </Content>
    </Layout>
  )
}
